import React from 'react';
import Radium from 'radium';
import { withRouter } from 'react-router-dom';

import {A} from 'views/AppElements';
import {Separator} from 'views/AppElements';

const styles = {
    searchInputDiv: {justifyContent: 'center', padding: '5px 10px', position: 'relative'},
    seachInputContainer: {width: '50%', paddingRight: '20px 5px', '@media (max-width: 770px)': {flexGrow: '1'}},
};

class SearchInput extends React.Component {

    constructor(props) {
        super(props);
        this.state = {keyword: props.keyword};
        this.fetchSearchLink = this.fetchSearchLink.bind(this);
        this.onSearch = this.onSearch.bind(this);
    }

    componentDidUpdate(prevProps) {
        if(prevProps.keyword !== this.props.keyword)
            this.setState({keyword: this.props.keyword});
    }
    onKeywordChange = (event) => {
        this.setState({keyword: event.target.value});
    }

    onKeyDown = (e) => {
        if (e.key === 'Enter') {
            const href = this.fetchSearchLink();
            this.props.history.push(href);
            this.onSearch();
        }
    }

    onSearch() {
        if(typeof this.props.onSearch === "function")
            this.props.onSearch(this.state.keyword)
    }

    fetchSearchLink() {
        const keyword = this.state.keyword;
        const href = keyword && keyword.length > 1? "/search/"+keyword: "#";
        return href;
    }

    render() {
        const href = this.fetchSearchLink();
        const title = this.props.title;
        return <div className="flexColumn searchInputContainer">
                {
                    title &&
                    <div>
                        <h1 style={styles.searchTitle} className="searchInputTitle">{title}</h1>
                        <Separator />
                    </div>
                }
                
                <div className="flexRow" style={[styles.searchInputDiv]}>
                    <div className="mui-textfield" style={styles.seachInputContainer}>
                        <input className="mui--is-untouched mui--is-pristine mui--is-not-empty" type="text" 
                                value={this.state.keyword} 
                                onChange={this.onKeywordChange} 
                                onKeyDown={this.onKeyDown}
                                placeholder="Influencers, Design, Artists and more..." 
                                ref={(input) => { this.searchInput = input; }} id="searchInput"/>
                    </div>
                    <A href={href} className="searchIconBtn" style={[this.props.btnStyle]} onClick={this.onSearch}><i className="fa fa-search" aria-hidden="true"></i></A>
                </div>    
            </div>
        
    }
}


export default withRouter(Radium(SearchInput));


// WEBPACK FOOTER //
// ./src/views/SearchInput.js